const purchaseTypes = {
    periodBookingPurchase: {},
    subscriptionBookingInitialPurchase: {},
    subscriptionBookingRecurringPurchase: {},
    endSubscriptionBookingPurchase: {},
    postInvoice: {},
    lockSystemAdditionalUserAddition: {}
};

Object.keys(purchaseTypes).forEach(key => {
    purchaseTypes[key].key = key;
});

export default purchaseTypes;
